import {Injectable} from '@angular/core';
import {GetPaymentMethodsService} from './paymentMethod/get-payment-methods.service';
import {UserService} from '../_services/user.service';
import * as globals from '../settings';
import {LotteriesService} from '../lotteries.service';
import {CurrencyService} from '../_services/currency.service';
import {TranslateService} from '@ngx-translate/core';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {RestartOrderService} from './restart-order.service';
import {Subscription} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PaystackSupportService {
    paystackKey = globals.paystackKey;
    devMode = globals.devMode;
    pmsCounter: number; /* number of PMs added to account */
    usePaystack: boolean; /* true if paystack is currently selected PM */
    paystackAllowed: boolean; /* true if paystack is avalible */
    forcePaystack: boolean; /* true if user force paystack */
    paystackMode: string; /* purchase or deposit */
    countryForPayments: string;
    generatedReferenceId: string;
    checkIfPaystack_result: any;
    brand = globals.brand;


    constructor(public getpmService: GetPaymentMethodsService,
                public userService: UserService,
                public lotteryService: LotteriesService,
                public currencyService: CurrencyService,
                public translate: TranslateService,
                public subscriptionsService: SubscriptionsService,
                public restartOrderService: RestartOrderService) {
        this.letsGo();

    }

    letsGo() {
        this.countryForPayments = localStorage.getItem('country');
        if (this.countryForPayments === 'NG'
            && this.currencyService.currency
            && this.currencyService.currency.Code
            && this.currencyService.currency.Code === 'NGN'
            && this.userService.userData
            && this.userService.userData.MemberID) {
            this.forcePaystack = false;
            this.countPayments();
            this.generateReferenceId();
        } else if (this.brand === 'winaija') {
            setTimeout(() => {
                this.letsGo();
            }, 500);
        }
    }

    resetAllVariables() {
        this.pmsCounter = 0;
        this.usePaystack = false;
        this.paystackAllowed = false;
        this.forcePaystack = false;
    }

    countPayments() {
        this.getpmService.getPaymentMethods();
        this.pmsCounter = this.getpmService.pmsCounter;
        this.validateIfPaystackAllowed();
        if (this.pmsCounter === undefined && this.userService.userData) {
            const pmsInterval = setInterval(() => {
                this.pmsCounter = this.getpmService.pmsCounter;
                if (this.pmsCounter !== undefined) {
                    this.validateIfPaystackAllowed();
                    clearInterval(pmsInterval);
                }
            }, 100);
        }
    }

    paystackBackgroundAction() {
        if (this.paystackMode === 'purchase') {
            const body = `purchaseAnyway=false&isGift=false&sessionId=${this.userService.userData.sessionId}&paymentOptionType=paystack&referenceId=${this.generatedReferenceId}`;
            this.lotteryService
                .postData(globals.appDomain + '/payments/purchaseOrder/' +
                    this.userService.userData.memberId
                    + '/purchaseOrder_forPaystack.json',
                    body)
                .subscribe(
                    result => {
                        // console.log({result});
                    }
                );
        }
    }

    validateIfPaystackAllowed() {
        if (this.paystackAllowed && (this.pmsCounter === 0 || this.forcePaystack)) {
            this.usePaystack = true;
        } else {
            this.usePaystack = false;
        }
    }

    checkIfPaystack() {
        if (this.countryForPayments === 'NG'
            && this.currencyService.currency
            && this.currencyService.currency.Code
            && this.currencyService.currency.Code === 'NGN'
            && this.userService.userData
            && this.userService.userData.sessionId) {
            /* HARDCODED becaouse of task: #3113 */
            this.checkIfPaystack_result = {
                'message': [{
                    'paymentMethod': 'Card',
                    'paymentMethodDisplayName': 'Card',
                    'logoURL': 'no value',
                    'isDirect': false,
                    'isWithdrawalAvailable': true,
                    'requiredFields': [{
                        'name': 'ccCardNumber',
                        'displayName': 'Card Number',
                        'type': 'string',
                        'minLength': 14,
                        'maxLength': 16,
                        'isRequired': true,
                        'extraInfo': {'class': 'short50'},
                        'min': null,
                        'max': null
                    }, {
                        'name': 'ccNameOnCard',
                        'displayName': 'Card owner name',
                        'type': 'string',
                        'minLength': 3,
                        'maxLength': 255,
                        'isRequired': true,
                        'extraInfo': {'class': 'short50'},
                        'min': null,
                        'max': null
                    }, {
                        'name': 'ccExpMonth',
                        'displayName': 'Month',
                        'type': 'select',
                        'minLength': null,
                        'maxLength': null,
                        'isRequired': true,
                        'extraInfo': {'class': 'short', 'collection': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]},
                        'min': null,
                        'max': null
                    }, {
                        'name': 'ccExpYear',
                        'displayName': 'Year',
                        'type': 'select',
                        'minLength': null,
                        'maxLength': null,
                        'isRequired': true,
                        'extraInfo': {
                            'class': 'short shortMargin10',
                            'collection': [19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44]
                        },
                        'min': null,
                        'max': null
                    }, {
                        'name': 'CVV',
                        'displayName': 'CVV',
                        'type': 'integer',
                        'minLength': null,
                        'maxLength': null,
                        'isRequired': true,
                        'extraInfo': {'class': 'short'},
                        'min': 100,
                        'max': 999
                    }, {
                        'name': 'email',
                        'displayName': 'E\u2013mail',
                        'type': 'hidden',
                        'minLength': 3,
                        'maxLength': 255,
                        'isRequired': false,
                        'extraInfo': {},
                        'min': null,
                        'max': null
                    }]
                }, {
                    'paymentMethod': 'paystack',
                    'paymentMethodDisplayName': 'PayStack',
                    'logoURL': '',
                    'requiredFields': {},
                    'isDirect': false,
                    'pendingAsFailed': false,
                    'isWithdrawalAvailable': true
                }], 'status': 200
            };
            /* HARDCODED */

            if (!this.checkIfPaystack_result) {
                this.lotteryService
                    .postData(globals.appDomain + '/payments/getAvailablePaymentOptions/getAvailablePaymentOptions_checkIfPaystack.json',
                        'countryCode=' + this.countryForPayments + '&lang=' + this.translate.currentLang +
                        '&currency=' + this.currencyService.currency.Code + '&SessionID=' + this.userService.userData.sessionId)
                    .subscribe(
                        result => {
                            this.checkIfPaystackCallback(result);
                        }
                    );
            } else {
                this.checkIfPaystackCallback(this.checkIfPaystack_result);
            }
        } else {
            this.paystackAllowed = false;
            this.validateIfPaystackAllowed();
        }
    }

    checkIfPaystackCallback(result) {
        this.checkIfPaystack_result = result;
        const isPaystack = result.message.filter(
            x => x.paymentMethod === 'paystack'
        ).length;
        if (isPaystack > 0) {
            this.paystackAllowed = true;
            this.validateIfPaystackAllowed();
        } else {
            this.paystackAllowed = false;
            this.validateIfPaystackAllowed();
        }
        localStorage.setItem('paystackFlow', '' + this.paystackAllowed);
    }

    generateReferenceId() {
        if (this.userService.userData && this.userService.userData.MemberID) {
            const currentTime = new Date().getTime();
            this.generatedReferenceId = this.userService.userData.MemberID + '' + currentTime;
        }
    }

    paymentDone($event) {
        this.pmsCounter = 1;
        this.usePaystack = false;
        this.generateReferenceId();
        this.subscriptionsService.updatePaymentMethod(true);
    }

    paymentCancel() {
        this.restartOrderService.restartOrder();
        setTimeout(() => {
            this.generateReferenceId();
        }, 0);
    }
}
